import { ApiResponse } from "../interfaces";

class ActionRefreshFormStrategy {
    private readonly actionFunction: () => void;
    private object: ApiResponse;
    constructor(func: () => void) {
        this.actionFunction = func;
    }

    /**
     * Определяет по объекту случай когда выполнится execute (Если условие проходит, то выполняется)
     * @param object
     */
    public shouldExecute(object: ApiResponse) {
        this.object = object;

        //Условие выполнится только если надо обновить форму и не надо ставить фокус на поле
        return object.refresh_form && !object.focus_control;
    }

    /**
     * Выполняет действие. Внутри вызывает функцию которая выполняет нужное действие
     */
    public execute() {
        this.actionFunction();
    }
}

export default ActionRefreshFormStrategy;